let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aF1bR")).then(() => parcelRequire('eco6J'));